import React from 'react';
import { Link } from 'react-router-dom';
import { ReservationReturn } from '../clients/rust-api-client';
import { Badge } from '../Components/Catalyst/badge';
import {
  formatLocalRange,
  statusColor,
  statusLabel,
} from './reservationFormat';

/** One booking in a list: what, when, and where it stands. */
const ReservationRow: React.FC<{ reservation: ReservationReturn }> = ({
  reservation: r,
}) => (
  <li>
    <Link
      to={`/reservations/${r.id}`}
      className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-zinc-200 bg-white px-4 py-3 transition hover:border-sky-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 dark:border-zinc-700 dark:bg-gray-800 dark:hover:border-sky-500"
    >
      <span className="min-w-0">
        <span className="block font-medium text-zinc-950 dark:text-white">
          {r.amenity_name}
        </span>
        <span className="block text-sm text-zinc-600 dark:text-zinc-400">
          {formatLocalRange(r.start_local, r.end_local)}
        </span>
      </span>
      <Badge color={statusColor(r.status)}>{statusLabel(r.status)}</Badge>
    </Link>
  </li>
);

export default ReservationRow;
